// MORE ON BASIC REGEXS: https://code.tutsplus.com/tutorials/8-regular-expressions-you-should-know--net-6149

function validateName(name) {
  const regex = /^[a-z ,.'-]+$/i;
  return regex.test(name);
}

function validateEmail(email) {
  const regex = /^([a-z0-9_.-]+)@([\da-z.-]+)\.([a-z.]{2,6})$/i;
  return regex.test(email);
}

function validatePhone(phone) {
  const regex = /^\(\d{3}\)\s\d{3}-\d{4}/;
  return regex.test(phone);
}

function hasText(requestType, minChars = 0) {
  if (requestType.length > minChars) {
    return true;
  }
  return false;
}

export default {
  name: validateName,
  email: validateEmail,
  phone: validatePhone,
  hasText
};



// WEBPACK FOOTER //
// ./src/util/formValidationMethods.js